import { getCrewMembersForRegistration } from '@shared/crew-members/endpoints/getCrewMembersForRegistration';
import { Options, OptionsQuery } from '@shared/ui/components/Select';

export const getCrewMemberOptionsForRegistration = (
  registrationId: number,
  { search, value }: OptionsQuery
): Promise<Options> =>
  getCrewMembersForRegistration(registrationId, {
    filter: { name_like: search, id: value },
    include: ['user'],
  }).then(({ data }) =>
    data.map((crewMember) => ({
      label: crewMember.user.fullName,
      value: crewMember.id,
    }))
  );
